import React, { ReactElement } from 'react';
import { Button } from '@components';
import { getIn, useFormikContext } from 'formik';
import styles from './NominationAccordions.module.scss';

interface iNominationAccordion1 {
  selectOptionName: string;
  closeOptionName: string;
  bodyContent: ReactElement;
  itemOption: string;
}
const NominationAccordion = ({ selectOptionName, closeOptionName, bodyContent, itemOption }: iNominationAccordion1): ReactElement => {
  const formikContext = useFormikContext();
  const CountryFields = [
    'StatecountryOfIssueSomeoneElse',
    'ResidentialAddressSomeoneElse.Country',
    'CompanyStreetAddressSomeoneElse.Country',
    'StatecountryOfIssueSoldDisposed',
    'ResidentialAddressSoldDisposed.Country',
    'CompanyStreetAddressSoldDisposed.Country'
  ];
  const FieldsToBeResetToFalse = [
    'DOBYesNoSomeoneElse',
    'NoDriverLicenseSomeoneElse',
    'isACNValidSomeoneElse',
    'NoOrgContactNumberSomeoneElse',
    'isABNValidSomeoneElse',
    'CompanyEmailYesNoSomeOneElse',
    'EvidenceSoldOrDisposeErrorHandle',
    'EvidenceSoldOrDisposeSizeErrorHandle',
    'EvidenceSoldOrDisposeFileUploadErrorHandle',
    'DOBYesNoSoldDisposed',
    'NoDriverLicenseSoldDisposed',
    'isACNValidSoldDisposed',
    'isABNValidSoldDisposed',
    'NoOrgContactNumberSoldDisposed',
    'VehicleOrIdentificationStolenOrFalseErrorHandle',
    'VehicleOrIdentificationStolenOrFalseSizeErrorHandle',
    'VehicleOrIdentificationStolenOrFalseFileUploadErrorHandle',
    'RejectionSupportingDocsErrorHandle',
    'RejectionSupportingDocsSizeErrorHandle',
    'RejectionSupportingDocsFileUploadErrorHandle',
    'UnableToIdentifyErrorHandle',
    'UnableToIdentifySizeErrorHandle',
    'UnableToIdentifyFileUploadErrorHandle'
  ];
  const FieldsToBeResetToNull = [
    'DOBSomeoneElse',
    'DateSellOrDispose',
    'DOBSoldDisposed',
  ];
  const FieldsToBeResetToEmptyArray = [
    'EvidenceSoldOrDispose',
    'VehicleOrIdentificationStolenOrFalse',
    'RejectionSupportingDocs',
    'UnableToIdentify',
  ];

  const SelectedGround0Fields = [
    'WhoAreYouNominating',
    'GivenNamesSomeoneElse',
    'FamilyNameSomeoneElse',
    'DOBSomeoneElse',
    'DOBYesNoSomeoneElse',
    'DriverLicenseSomeoneElse',
    'LicenceStateSomeoneElse',
    'StatecountryOfIssueSomeoneElse',
    'NoDriverLicenseSomeoneElse',
    'TaxDriverAccNumber',
    'ResidentialAddressSomeoneElse.SearchText',
    'ResidentialAddressSomeoneElse.Address',
    'ResidentialAddressSomeoneElse.LineOne',
    'ResidentialAddressSomeoneElse.LineTwo',
    'ResidentialAddressSomeoneElse.Suburb',
    'ResidentialAddressSomeoneElse.State',
    'ResidentialAddressSomeoneElse.Postcode',
    'ResidentialAddressSomeoneElse.Country',
    'NoResidentialAddressSomeoneElse',
    'NoEmailSomeoneElse',
    'EmailSomeoneElse',
    'IndividualContactNumberSomeoneElse.ContactNumber',
    'NoContactNumberSomeoneElse',
    'CompanyNameSomeoneElse',
    'AbnacnTypeSomeoneElse',
    'AcnNoSomeoneElse',
    'isACNValidSomeoneElse',
    'NoOrgContactNumberSomeoneElse',
    'AbnNoSomeoneElse',
    'isABNValidSomeoneElse',
    'CompanyStreetAddressSomeoneElse.SearchText',
    'CompanyStreetAddressSomeoneElse.Address',
    'CompanyStreetAddressSomeoneElse.LineOne',
    'CompanyStreetAddressSomeoneElse.LineTwo',
    'CompanyStreetAddressSomeoneElse.Suburb',
    'CompanyStreetAddressSomeoneElse.State',
    'CompanyStreetAddressSomeoneElse.Postcode',
    'CompanyStreetAddressSomeoneElse.Country',
    'OrganisationContactNumberSomeoneElse.ContactNumber',
    'CompanyEmailSomeOneElse',
    'CompanyEmailYesNoSomeOneElse',
  ];
  const SelectedGround1Fields = [
    'TransferedVicRoads',
    'DateSellOrDispose',
    'EvidenceSoldOrDispose',
    'EvidenceSoldOrDisposeNameField',
    'EvidenceSoldOrDisposeProvider',
    'EvidenceSoldOrDisposeFilesDescription',
    'EvidenceSoldOrDisposeErrorHandle',
    'EvidenceSoldOrDisposeSizeErrorHandle',
    'EvidenceSoldOrDisposeFileUploadErrorHandle',
    'EvidenceSoldOrDisposeFileSectionError',
    'WhoAreYouNominatingSoldDispose',
    'GivenNamesSoldDisposed',
    'FamilyNameSoldDisposed',
    'DOBSoldDisposed',
    'DOBYesNoSoldDisposed',
    'DriverLicenseSoldDisposed',
    'LicenceStateSoldDisposed',
    'StatecountryOfIssueSoldDisposed',
    'NoDriverLicenseSoldDisposed',
    'ResidentialAddressSoldDisposed.SearchText',
    'ResidentialAddressSoldDisposed.Address',
    'ResidentialAddressSoldDisposed.LineOne',
    'ResidentialAddressSoldDisposed.LineTwo',
    'ResidentialAddressSoldDisposed.Suburb',
    'ResidentialAddressSoldDisposed.State',
    'ResidentialAddressSoldDisposed.Postcode',
    'ResidentialAddressSoldDisposed.Country',
    'NoEmailSoldDisposed',
    'EmailSoldDisposed',
    'IndividualContactNumberSoldDisposed.ContactNumber',
    'NoContactNumberSoldDisposed',
    'CompanyNameSoldDisposed',
    'AbnacnTypeSoldDisposed',
    'AcnNoSoldDisposed',
    'isACNValidSoldDisposed',
    'OrganisationContactNumberYesNoSoldDisposed',
    'AbnNoSoldDisposed',
    'isABNValidSoldDisposed',
    'CompanyStreetAddressSoldDisposed.SearchText',
    'CompanyStreetAddressSoldDisposed.Address',
    'CompanyStreetAddressSoldDisposed.LineOne',
    'CompanyStreetAddressSoldDisposed.LineTwo',
    'CompanyStreetAddressSoldDisposed.Suburb',
    'CompanyStreetAddressSoldDisposed.State',
    'CompanyStreetAddressSoldDisposed.Postcode',
    'CompanyStreetAddressSoldDisposed.Country',
    'OrganisationContactNumberSoldDisposed.ContactNumber',
    'NoOrgContactNumberSoldDisposed',
    'CompanyEmailSoldDisposed',
    'CompanyEmailYesNoSoldDisposed',
  ];

  const SelectedGround2Fields = [
    'VictoriaPoliceReferenceNumber',
    'VehicleOrIdentificationStolenOrFalse',
    'VehicleOrIdentificationStolenOrFalseNameField',
    'VehicleOrIdentificationStolenOrFalseProvider',
    'VehicleOrIdentificationStolenOrFalseDescription',
    'VehicleOrIdentificationStolenOrFalseErrorHandle',
    'VehicleOrIdentificationStolenOrFalseSizeErrorHandle',
    'VehicleOrIdentificationStolenOrFalseFileUploadErrorHandle',
    'VehicleOrIdentificationStolenOrFalseFileSectionError',
  ];

  const SelectedGround3Fields = [
    'IncorrectNominationExplanation',
    'RejectionSupportingDocs',
    'RejectionSupportingDocsNameField',
    'RejectionSupportingDocsProvider',
    'RejectionSupportingDocsDescription',
    'RejectionSupportingDocsErrorHandle',
    'RejectionSupportingDocsSizeErrorHandle',
    'RejectionSupportingDocsFileUploadErrorHandle',
    'RejectionSupportingDocsFileSectionError',
  ];

  const SelectedGround4Fields = [
    'UnableToIdentifyExplanation',
    'UnableToIdentify',
    'UnableToIdentifyNameField',
    'UnableToIdentifyProvider',
    'UnableToIdentifyDescription',
    'UnableToIdentifyErrorHandle',
    'UnableToIdentifySizeErrorHandle',
    'UnableToIdentifyFileUploadErrorHandle',
    'UnableToIdentifyFileSectionError',
  ];
  const SelectedGroundsFields: Map<string, string[]> = new Map();
  SelectedGroundsFields.set('SelectedGroundInfo0', SelectedGround0Fields);
  SelectedGroundsFields.set('SelectedGroundInfo1', SelectedGround1Fields);
  SelectedGroundsFields.set('SelectedGroundInfo2', SelectedGround2Fields);
  SelectedGroundsFields.set('SelectedGroundInfo3', SelectedGround3Fields);
  SelectedGroundsFields.set('SelectedGroundInfo4', SelectedGround4Fields);

  const resetValuesUponSelection = (fields: string[]) => {
    fields.forEach((field) => {
      if (CountryFields.includes(field)) {
        formikContext.setFieldValue(field, 'Australia');
      } else if (FieldsToBeResetToFalse.includes(field)) {
        formikContext.setFieldValue(field, false);
      } else if (FieldsToBeResetToNull.includes(field)) {
        formikContext.setFieldValue(field, null);
      } else if (FieldsToBeResetToEmptyArray.includes(field)) {
        formikContext.setFieldValue(field, []);
      } else {
        formikContext.setFieldValue(field, '');
      }
      formikContext.setFieldTouched(field, false);
    });
  };

  return (
    <div>
      {bodyContent}
      <br />
      <div className={styles.buttonContainer}>
        <div className={styles.buttons}>
          <Button
            className={styles.backBtn}
            color="white"
            size="small"
            onClick={() => {
              formikContext.setFieldValue(closeOptionName, itemOption);
              formikContext.setFieldTouched(closeOptionName);
            }}
          >
            Close
          </Button>
          <Button
            className={styles.continueBtn}
            onClick={async () => {
              if (getIn(formikContext.values, selectOptionName)) {
                resetValuesUponSelection(SelectedGroundsFields.get(getIn(formikContext.values, selectOptionName))!);
              }
              await formikContext.setFieldValue(selectOptionName, itemOption);
              await formikContext.setFieldTouched(selectOptionName);
              formikContext.validateField(selectOptionName);
            }}
          >
            Select this option
          </Button>
        </div>
      </div>
    </div>
  );
};

export default NominationAccordion;
